<div class="icon-container">
  <div
    class="icon"
    [ngClass]="backgroundColor + '-background'"
    [ngStyle]="{ height: backgroundSize + 'px', width: backgroundSize + 'px' }"
    [ngSwitch]="icon"
  >
    <mat-icon
      [ngClass]="iconColor"
      [ngStyle]="{ height: iconSize + 'px', width: iconSize + 'px', 'font-size': iconSize + 'px' }"
      *ngSwitchCase="'check'"
    >
      check
    </mat-icon>
    <mat-icon
      [ngClass]="iconColor"
      [ngStyle]="{ height: iconSize + 'px', width: iconSize + 'px', 'font-size': iconSize + 'px' }"
      *ngSwitchCase="'sync'"
    >
      sync
    </mat-icon>
    <mat-icon
      [ngClass]="iconColor"
      [ngStyle]="{ height: iconSize + 'px', width: iconSize + 'px', 'font-size': iconSize + 'px' }"
      *ngSwitchCase="'check_circle'"
    >
      check_circle
    </mat-icon>
    <mat-icon
      [ngClass]="iconColor"
      [ngStyle]="{ height: iconSize + 'px', width: iconSize + 'px', 'font-size': iconSize + 'px' }"
      *ngSwitchCase="'check_circle_outline'"
    >
      check_circle_outline
    </mat-icon>
    <mat-icon
      [ngClass]="iconColor"
      [ngStyle]="{ height: iconSize + 'px', width: iconSize + 'px', 'font-size': iconSize + 'px' }"
      *ngSwitchDefault
    >
      close
    </mat-icon>
  </div>
  <div class="text" *ngIf="text">{{ text }}</div>
</div>
